<template>
  <crud-modal
    title="Creatify Template hinzufügen"
    action="create"
    :on-submit="submit"
    :on-close="() => $emit('close')"
  >
    <div class="mb-6">
      <input-text-validated
        ref="name"
        v-model="name"
        input-class="w-full"
        label="Kampagne Name"
        rules="required"
        placeholder="Bundestagswahl 2021"
      />
    </div>

    <div class="mb-6">
      <input-text-validated
        ref="templateId"
        v-model="templateId"
        input-class="w-full"
        label="Template Id"
        rules="required"
        placeholder="763fdeae-b11b-4b9c-b27a-77c9c9556afe"
      />
    </div>

    <div class="variants-container mb-6">
      <h3 class="font-semibold mb-2">
        Varianten
      </h3>
      <div
        v-for="(variantItem, index) in variants"
        :key="index"
        class="variant-item mb-4 p-4 border rounded"
      >
        <div class="flex justify-between mb-2">
          <h4 class="font-medium">
            Variante {{ index + 1 }}
          </h4>
          <button
            class="text-red-600 hover:text-red-800"
            @click="removeVariant(index)"
          >
            Entfernen
          </button>
        </div>

        <div class="mb-4">
          <input-select-validated
            v-model="variantItem.variant"
            input-class="w-full"
            label="Variante"
            rules="required"
            :options="variantOptions"
          />
        </div>

        <div class="mb-2">
          <input-text-validated
            v-model="variantItem.templateId"
            input-class="w-full"
            label="Template ID"
            rules="required"
            placeholder="763fdeae-b11b-4b9c-b27a-77c9c9556afe"
          />
        </div>
      </div>

      <button
        class="mt-2 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        @click="addVariant"
      >
        Variante hinzufügen
      </button>
    </div>
  </crud-modal>
</template>

<script>
import CrudModal from '@/components/modals/crud-modal'
import InputSelectValidated from '@/components/form/select-validated'
import InputTextValidated from '@/components/form/text-validated'

import GET_CAMPAIGN from '@/graphql/GetCampaign.gql'
import CREATE_VIDEO_MATERIAL_TEMPLATE_FOR_CAMPAIGN from '@/graphql/CreateVideoMaterialTemplateForCampaign.gql'

export default {
  components: { CrudModal, InputSelectValidated, InputTextValidated },
  props: {
    campaignId: { type: String, required: true }
  },
  data () {
    return {
      name: '',
      templateId: '',
      variants: [],
      variantOptions: [
        { value: 'DV1', name: 'DV1' },
        { value: 'DV2', name: 'DV2' },
        { value: 'DV3', name: 'DV3' },
        { value: 'DV4', name: 'DV4' },
        { value: 'REMAX', name: 'REMAX' },
        { value: 'VOLKSBANK', name: 'VOLKSBANK' },
        { value: 'CHV1', name: 'CHV1' },
        { value: 'CHV2', name: 'CHV2' },
        { value: 'CHIT', name: 'CHIT' },
        { value: 'CHFR', name: 'CHFR' },
        { value: 'ATV1', name: 'ATV1' },
        { value: 'LIGHT', name: 'LIGHT' }
      ]
    }
  },
  methods: {
    addVariant () {
      this.variants.push({
        variant: '',
        templateId: ''
      })
    },
    removeVariant (index) {
      this.variants.splice(index, 1)
    },
    async submit () {
      this.$apollo.mutate({
        mutation: CREATE_VIDEO_MATERIAL_TEMPLATE_FOR_CAMPAIGN,
        variables: {
          input: {
            campaignId: this.campaignId,
            name: this.name,
            templateId: this.templateId,
            variants: this.variants
          }
        },
        refetchQueries: [{ query: GET_CAMPAIGN, variables: { campaignId: this.campaignId } }]
      })
    }
  }
}
</script>
